import { Modal } from '@hose/eui';
import { FilledTipsWarning } from '@hose/eui-icons';
import React from 'react';
export var showWarningModal = function (fn) {
    Modal.confirm({
        title: i18n.get('删除发票'),
        content: i18n.get('确认是否删除此张发票，删除后无法撤回，请谨慎操作'),
        icon: (React.createElement(FilledTipsWarning, null)),
        okButtonProps: { theme: 'danger' },
        okText: (i18n.get('确定')),
        cancelText: (i18n.get('取消')),
        onCancel: function () {
            closeModal();
        },
        onOk: function () {
            closeModal();
            fn && fn();
        }
    });
};
var closeModal = function () {
    Modal.destroyAll();
};
